import { render, staticRenderFns } from "./examevalidacao.vue?vue&type=template&id=e08487c6&scoped=true"
import script from "./examevalidacao.vue?vue&type=script&lang=js"
export * from "./examevalidacao.vue?vue&type=script&lang=js"
import style0 from "./examevalidacao.vue?vue&type=style&index=0&id=e08487c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08487c6",
  null
  
)

export default component.exports